// extracted by mini-css-extract-plugin
export default {"productCarousel":"C1-z"};